import {captureException} from "@sentry/react";
import React from 'react';
import {PolIcon} from "../PolIcon/policon";
import PolButton from "v4/components/ui/PolButton/PolButton";
import {withTranslation} from "react-i18next";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            maxRetries: props.maxRetries ?? 3,
        };
    }

    componentDidCatch(error, info) {
        captureException(error)
        this.setState({
            hasError: true
        });
    }

    refresh = (refreshCallback) => {
        this.setState(state => ({
            hasError: false,
            maxRetries: state.maxRetries - 1
        }));

        if (refreshCallback) {
            refreshCallback();
        }
    }

    render() {
        const {
            t,
            className = '',
            canRetry = false,
            isErrorShowing = false,
            refreshCallback,
            children
        } = this.props;
        const {hasError, maxRetries} = this.state;

        if (!hasError && !isErrorShowing) return children;

        return (
            <div className={`${className} page-error-component`}>
                <div className="page-error-component__content">
                    <PolIcon icon="exclamation-circle" className="error-icon"/>
                    <p className="error-text mb-3">{t("error_content_loaded")}</p>
                    {(maxRetries > 0 && canRetry) && (
                        <PolButton onClick={() => this.refresh(refreshCallback)}>
                            {t('retry')}
                        </PolButton>
                    )}
                </div>
            </div>
        );
    }
}

export default withTranslation()(ErrorBoundary);
